import dayjs from "dayjs";
import SwaggerClient from "swagger-client";
import store from "./store";

// common properties
SwaggerClient.http.withCredentials = true;

const authorizations = function () {
  return {
    api_key: process.env.VUE_APP_CLIENT_APPLICATION_KEY
  };
};

const baseURL = window.location.origin;

/**
 * Build request parameters to be passed to Swaggerclient library
 * @param {*} requestBody The request body
 */
const buildRequest = function (requestBody) {
  return {
    requestBody: requestBody,
    server: "{protocol}://{hostAndPort}{basePath}{apiPath}",
    serverVariables: {
      protocol: process.env.VUE_APP_ONSTAGE_GATEWAY_PROTOCOL,
      hostAndPort: process.env.VUE_APP_ONSTAGE_GATEWAY_HOST_AND_PORT,
      basePath: process.env.VUE_APP_ONSTAGE_GATEWAY_BASE_PATH
    }
  };
};

const hfportalSpecUrl = baseURL.concat("/hfportal-v1.json");
const hfportalSwaggerClient = new SwaggerClient(hfportalSpecUrl, {
  requestInterceptor: request => {
    if (store?.getters["session/actionMoment"]) {
      store.commit("session/newActionMoment");
      let newActionMoment = store.getters["session/newActionMoment"];
      let oldActionMoment = store.getters["session/actionMoment"];
      let actionMomentDifference = dayjs(newActionMoment).diff(
        dayjs(oldActionMoment),
        "minute"
      );
      /**
       * If the session is expired, call the mutation to reset the
       * store login basic auth property: the authentication manager returns
       * 403 (com.bizmatica.onair.core.model.runtime.security.AuthorizationException);
       * Otherwise reset session actionMoment property with nowActionMoment.
       */
      if (actionMomentDifference >= store.getters["session/sessionDuration"]) {
        let username = "username";
        let password = "password";
        store.commit("auth/SET_USER_AUTH_TOKEN", {
          username,
          password
        });
      } else {
        store.commit("session/resetActionMoment");
      }
    }
    if (store) {
      let urlsFroAutocompleteActions = [
        "serviceNames",
        "checkFascicoloGenerationByBulkDocuments"
      ];
      if (
        !urlsFroAutocompleteActions.some(rUrl => request.url.includes(rUrl))
      ) {
        const LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
        store.commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
          root: true
        });
      }
    }
    request.headers["Accept"] = "application/json";
    if (store?.getters["auth/loginBasicAuth"]) {
      request.headers["Authorization"] = store.getters["auth/loginBasicAuth"];
    }
    return request;
  },
  responseInterceptor: response => {
    if (store) {
      store.commit("loading/CLOSE_LOADING_DIALOG", {
        root: true
      });
    }
    return response;
  },
  authorizations: authorizations()
});

// user/v1 specific properties
const userSpecUrl = baseURL.concat("/user-v1.json");
const userSwaggerClient = new SwaggerClient(userSpecUrl, {
  requestInterceptor: request => {
    if (store?.getters["session/actionMoment"]) {
      store.commit("session/newActionMoment");
      let newActionMoment = store.getters["session/newActionMoment"];
      let oldActionMoment = store.getters["session/actionMoment"];
      let actionMomentDifference = dayjs(newActionMoment).diff(
        dayjs(oldActionMoment),
        "minute"
      );
      /**
       * If the session is expired, call the mutation to reset the
       * store login basic auth property: the authentication manager returns
       * 403 (com.bizmatica.onair.core.model.runtime.security.AuthorizationException);
       * Otherwise reset session actionMoment property with nowActionMoment.
       */
      if (actionMomentDifference >= store.getters["session/sessionDuration"]) {
        let username = "username";
        let password = "password";
        store.commit("auth/SET_USER_AUTH_TOKEN", {
          username,
          password
        });
      } else {
        store.commit("session/resetActionMoment");
      }
    }
    if (store?.getters["auth/useLoadingDialog"]) {
      const LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      store.commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
    }
    request.headers["Accept"] = "application/json";
    if (store?.getters["auth/loginBasicAuth"]) {
      request.headers["Authorization"] = store.getters["auth/loginBasicAuth"];
    }
    if (store?.getters["tenants/firstTenantId"]) {
      request.headers["TENANT_ID"] =
        store.getters["tenants/firstTenantId"].tenantId;
    }
    return request;
  },
  responseInterceptor: response => {
    if (store?.getters["auth/useLoadingDialog"]) {
      store.commit("loading/CLOSE_LOADING_DIALOG", {
        root: true
      });
    }
    return response;
  },
  authorizations: authorizations()
});

export default {
  userSwaggerClient,
  hfportalSwaggerClient,
  buildRequest,
  authorizations
};
